"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum to order the settings shown within the quick settings pane.
 * Each setting that is shown in the quick settings pane should have a unique entry
 * in the enum, and in the order to be shown in the quick settings pane.
 */
var QuickSettingOrder;
(function (QuickSettingOrder) {
    // All workloads
    QuickSettingOrder[QuickSettingOrder["Theme"] = 0] = "Theme";
    // Mail workload
    QuickSettingOrder[QuickSettingOrder["Conversations"] = 1] = "Conversations";
    QuickSettingOrder[QuickSettingOrder["ReadingPane"] = 2] = "ReadingPane";
    QuickSettingOrder[QuickSettingOrder["Focused"] = 3] = "Focused";
    QuickSettingOrder[QuickSettingOrder["SenderImage"] = 4] = "SenderImage";
    QuickSettingOrder[QuickSettingOrder["DateHeaders"] = 5] = "DateHeaders";
    QuickSettingOrder[QuickSettingOrder["InlinePreview"] = 6] = "InlinePreview";
    QuickSettingOrder[QuickSettingOrder["PreviewText"] = 7] = "PreviewText";
})(QuickSettingOrder || (QuickSettingOrder = {}));
exports.default = QuickSettingOrder;
//# sourceMappingURL=QuickSettingOrder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/store/schema/QuickSettingOrder.js
// module id = 1825
// module chunks = 2 39 105 108